module.exports = __webpack_public_path__ + "static/media/TRX-BUSD.4c6892ad.svg";